/**
 * @Author: wence@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 15:28:30
 * @FilePath: /m-anquan-baidu-com/src/containers/product/page_temperature.js
 * @Description: ai体温检测解决方案
 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';

import './page_temperature.less';

export default class PageTemperature extends PureComponent {
    static propTypes = {
        bannerInfo: PropTypes.object
    }

    render() {
        const bannerInfo = this.props.bannerInfo || {};

        return (
            <div className={'product'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    基于百度AI图像识别技术和红外热成像技术的整合，形成完善的多人体温快速检测方案，可对人流中多人额头温度同时进行快速筛选及预警，方便人流聚集处的快速筛选。支持固定检测点和使用移动设备进行巡检两种模式。
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title="解决方案简介" />
                </div>


                <div className="saas-p-des">
                    使⽤人脸检测关键点定位（精准定位包括脸颊、眉、眼、口、鼻等人脸五官及轮廓的150个关键点）及图像红外温度点阵温度分析算法，
                    可以在⼀定⾯积范围内批量对多人同时进行体温筛查。 实时监测多人流场景动态，对体温超出⼀定阈值的人员，系统予以告警，
                    帮助工作⼈员迅速查出温度可疑⼈员，采取有效措施。
                </div>

                <div className="saas-p-img des-img1"></div>
                <div className="saas-p-des-title">固定点位检测</div>
                <div className="saas-p-des-sub">⼈流从固定监测点前面经过，监测点的设备采集人脸和体温信息进行分析筛查。发现温度异常对象再使用额温枪进⾏⼆次筛查，提升⼈流通过效率。</div>

                <div className="saas-p-img des-img2"></div>
                <div className="saas-p-des-title">移动巡查</div>
                <div className="saas-p-des-sub">使⽤移动设备对人群进⾏⾮接触式批量巡查，发现温度异常对象再使⽤额温枪进行⼆次筛查，提升巡查效率。</div>

                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title="业务结构" />
                </div>

                <div className="saas-p-img tree-img"></div>


                <div className="saas-p-sence-container">
                    <div className={'product-mod'}>
                        <ProductTitle title="业务场景" />
                    </div>
                    {
                        [
                            {
                                title: '地铁/高铁/车站/机场卡点多人体温检测预警',
                                img: require('../../asset/image/page_temperature/pic_ditie_wap.png')
                            },
                            {
                                title: '安防领域热成像',
                                img: require('../../asset/image/page_temperature/pic_anfang_wap.png')
                            },
                            {
                                title: '电力、石油、化工等行业热成像监控',
                                img: require('../../asset/image/page_temperature/pic_dianli_wap.png')
                            }
                        ].map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    style={{backgroundImage: `url(${item.img})`}}
                                    className="saas-p-sence-item">
                                    {item.title}
                                </div>
                            );
                        })
                    }
                </div>

                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title="方案优势" />
                </div>
                <div className="saas-p-advantage">
                    {
                        [
                            {
                                title: '实时高效',
                                des: (<div>
                                    <div>在单⼈通道顺序通行条件下，可在1分钟内实现对逾200⼈同时通过的体温实时检测，实现⼈群无停留过检，缓解人员堵塞。</div>
                                    <div>*参考数据，受⼈群密度及行进速度影响。</div>
                                </div>),
                                url: require('../../asset/image/page_temperature/icon_shishigaoxiao_wap.svg')
                            },
                            {
                                title: '精准可靠',
                                des: '实现了体温检测与人脸识别的技术同步及佩戴⼝罩时的识别问题，可准确定位、快速锁定体温异常人员并实时⾃动告警，⽅便⼯作人员进行⼆次复检。',
                                url: require('../../asset/image/page_temperature/icon_jingzhunkekao_wap.svg')
                            },
                            {
                                title: '非接触无感知',
                                des: '借助全⾃动化的体温检测，被检人员仅需做弱配合，大幅减少相互的近距离接触，降低潜在的安全隐患。',
                                url: require('../../asset/image/page_temperature/icon_feijiechuwuganzhi_wap.svg')
                            },
                            {
                                title: '快速部署降低成本',
                                des: '实现检测结果的实时可视化，并可在通道、重要区域快速部署，有效降低成本，缓解疫情防控期间紧张的⼈力资源调配。',
                                url: require('../../asset/image/page_temperature/icon_dichengben_wap.svg')
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-p-advantage-item">
                                    <div className="icon" style={{backgroundImage: `url(${item.url})`}}></div>
                                    <div className="content">
                                        <div className="title">{item.title}</div>
                                        <div className="des">{item.des}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>

                <div style={{background: '#F5F5F5', padding: '1rem 0'}}>
                    <div className={'product-mod'}>
                        <ProductTitle title="成功案例" />
                    </div>

                    <div className="saas-p-case-img"></div>
                    <div className="saas-p-case-title">合作伙伴：</div>
                    <div className="saas-p-case-sub">北京清河高铁站</div>
                    <div className="saas-p-case-title" style={{marginTop: '.4rem'}}>应用场景：</div>
                    <div className="saas-p-case-sub">⼈流从固定检测点通过，⽆须停留逐个体温检测，百度AI多⼈体温检测方案的边缘设备自动进⾏⼈脸和体温信息的采集分析，
                        精准识别旅客及对应的体温，一旦发现体温异常，⻋站⼯作⼈员能第一时间监测到并示意其出列，用⼿持设备进行⼆次检测。
                        通过应⽤百度AI体温检测解决方案，可以更好地应对客流高峰，快速完成体温检测，提升人流通过效率的同时，保证工作人员的安全。</div>
                </div>
                <div></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/product/page_temperature.js